import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountDestinationsRepository } from '@/core/domain/count-destinations/repositories/count-destinations.repository';
import { GetCountDestinationsUseCase } from '@/core/domain/count-destinations/usecases/getCountDestinations.usecase';
import { CountDestinationsImplRepository } from './count-destinations-impl.repository';

const GetCountDestinationsUseCaseFactory = (
    countDestinationsRepository: CountDestinationsRepository,
) => new GetCountDestinationsUseCase(countDestinationsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetCountDestinationsUseCase,
            useFactory: GetCountDestinationsUseCaseFactory,
            deps: [CountDestinationsRepository],
        },
        {
            provide: CountDestinationsRepository,
            useClass: CountDestinationsImplRepository,
        },
    ],
})
export class CountDestinationsDataModule {}
